/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Továrna na ovladače pro zobrazování obrázkových souborů.
 */
class ImageViewerControllerFactory {
  /**
   * Vytvoří instanci.
   * @param {Class.<ImageViewerController>} ImageViewerController
   * @param {ViewerLifeCycleFactory} lifeCycleFactory
   */
  constructor(ImageViewerController, lifeCycleFactory) {
    this.ImageViewerController = ImageViewerController;
    this.lifeCycleFactory = lifeCycleFactory;
  }

  /**
   * Vytvoří ovladač.
   * @returns {ImageViewerController}
   */
  create() {
    return new this.ImageViewerController(this.lifeCycleFactory);
  }
}

export default ImageViewerControllerFactory;
